import { USER_GIFS } from '../config/appConfig';

function hashAddr(addr) {
  let h = 0x811c9dc5;
  const s = (addr || '').toLowerCase();
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
  }
  return h >>> 0;
}

export function pickAvatar(address) {
  if (!address) return USER_GIFS[0];
  return USER_GIFS[hashAddr(address) % USER_GIFS.length];
}
